module.exports = __webpack_public_path__ + "media/images/plans/e-photo_studio/main-bcd65e4032070126cd92987fbfc761db.png";